import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { api, setAuth } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAuth(data.access_token, data.user);
      toast.success(`Selamat datang, ${data.user.name}`);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal masuk");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50/70 bg-grid px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-1.5 text-slate-600 hover:text-slate-900 text-sm mb-6" data-testid="back-to-home-link">
          <ArrowLeft className="w-4 h-4" /> Kembali ke Beranda
        </Link>

        <Card className="border-slate-200 shadow-lg rounded-2xl">
          <CardHeader className="text-center pb-4">
            <img src="/logo-sekolah.png" alt="Logo SMPN 1 Penengahan" className="w-20 h-20 mx-auto mb-3 object-contain" />
            <CardTitle className="text-2xl font-display font-bold text-slate-900">Masuk Admin Tata Usaha</CardTitle>
            <CardDescription>SMP Negeri 1 Penengahan • Buku Induk Digital</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-slate-700">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="email@sekolah.sch.id"
                  className="mt-1.5 h-11"
                  required
                  data-testid="admin-email-input"
                />
              </div>
              <div>
                <Label htmlFor="password" className="text-slate-700">Kata Sandi</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="mt-1.5 h-11"
                  required
                  data-testid="admin-password-input"
                />
              </div>
              <Button type="submit" disabled={loading} className="w-full h-11 bg-blue-700 hover:bg-blue-800 rounded-lg" data-testid="admin-login-submit-button">
                {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
                Masuk
              </Button>
            </form>
            <p className="mt-6 text-xs text-center text-slate-500">
              Akses siswa tidak memerlukan login. <Link to="/siswa" className="text-blue-700 hover:underline font-medium">Portal Siswa →</Link>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
